import React from 'react';
import '../../pages/LandingPage.css';
import SectionBackground from './SectionBackground';

const problems = [
  {
    stat: '$5,000+',
    description: 'Average cost of eviction case lost due to lease errors',
  },
  {
    stat: '3x',
    description: 'Damages for missing AB 1482 rent control notice',
  },
  {
    stat: '72%',
    description: 'Of DIY leases missing required CA disclosures',
  },
];

const ProblemSection: React.FC = () => {
  return (
    <SectionBackground style={{ padding: '80px 20px' }}>
      <div className="container">
        <h2 style={{
          textAlign: 'center',
          fontSize: '2.5rem',
          marginBottom: '40px',
          color: 'white',
          fontWeight: 700,
        }}>
          The Hidden Cost of Getting California Leases Wrong
        </h2>
        <div className="features-grid">
          {problems.map((problem, idx) => (
            <div 
              className="feature-card" 
              key={idx}
              style={{
                textAlign: 'center',
                background: 'rgba(255, 255, 255, 0.05)',
                backdropFilter: 'blur(10px)',
                border: '1px solid rgba(255, 255, 255, 0.1)',
                borderRadius: '16px',
                boxShadow: '0 8px 32px rgba(0, 0, 0, 0.1)',
              }}
            >
              <div style={{
                fontSize: '3rem',
                color: '#ec4899',
                marginBottom: '10px',
                fontWeight: 700,
              }}>
                {problem.stat}
              </div>
              <div style={{ fontWeight: 600, color: '#d1d5db' }}>
                {problem.description}
              </div>
            </div>
          ))}
        </div>
      </div>
    </SectionBackground>
  );
};

export default ProblemSection; 